// extracted by mini-css-extract-plugin
export default {"listItem":"UserListItem_listItem__lOm4L","content":"UserListItem_content__6nII0","title":"UserListItem_title__FP8Lo","text":"UserListItem_text__0xOw8"};